export default __webpack_public_path__ + "images/ce65363499389e3186f02e0de8f4d91c-government.webp";